import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PortfolioLeaderboardItem {
  portfolio_item_id: string;
  title: string;
  images: number;
  views: number;
}

export function usePortfolioLeaderboard(profileId: string | undefined) {
  return useQuery({
    queryKey: ['portfolioLeaderboard', profileId],
    queryFn: async () => {
      if (!profileId) return [];
      const { data, error } = await supabase.rpc('get_portfolio_leaderboard', { profile_id: profileId });
      if (error) throw error;
      return data || [];
    },
    enabled: !!profileId,
  });
} 